var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "023FDBBE-3127-4117-953D-E1AA506478F8") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ficha-del-Proyecto--|-modo-edici\\xF3n-activado",
    transform: "translate(-1238.000000, -1377.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(588.000000, 1314.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(19.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button/acepto-blue",
    transform: "translate(617.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(14.100000, 8.214286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33296,6.94864 L3.3048,7.9768 L6.6096,11.2816 L13.9536,3.9376 L12.92544,2.90944 L6.6096,9.22528 L4.33296,6.94864 Z M13.2192,8.344 C13.2192,11.57536 10.57536,14.2192 7.344,14.2192 C4.11264,14.2192 1.4688,11.57536 1.4688,8.344 C1.4688,5.11264 4.11264,2.4688 7.344,2.4688 C7.93152,2.4688 8.4456,2.54224 8.95968,2.68912 L10.1347488,1.51408 C9.25344,1.22032 8.29872,1 7.344,1 C3.3048,1 -8.58868532e-13,4.3048 -8.58868532e-13,8.344 C-8.58868532e-13,12.3832 3.3048,15.688 7.344,15.688 C11.3832,15.688 14.688,12.3832 14.688,8.344 L13.2192,8.344 Z",
    id: "Shape"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.4fc7bc1d8e681b516065828d73d48f2f.svg";
export { ForwardRef as ReactComponent };